import React, { useEffect, useState, useContext } from 'react';
import {
  MDBContainer,
  MDBCollapse,
  MDBNavbar,
  MDBNavbarToggler,
  MDBIcon,
  MDBBtn,
} from 'mdb-react-ui-kit';
import { NavLink } from 'react-router-dom';
import UserContext from '../../contexts/UserContext';
import { BsPersonCircle } from 'react-icons/bs';
import Offcanvas from 'react-bootstrap/Offcanvas';

export default function App(props) {
  const {user} = useContext(UserContext);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <MDBNavbar>
        <MDBContainer fluid>
        <NavLink to="/home"> <img src='/fmb_logo.png' width={70}></img></NavLink>
          {user?<BsPersonCircle
            className='ms-auto'
            type='button'
            data-target='#navbarToggleExternalContent'
            aria-controls='navbarToggleExternalContent'
            aria-expanded='false'
            aria-label='Toggle navigation'
            onClick={handleShow}
          >
          </BsPersonCircle>:null}
        </MDBContainer>
      </MDBNavbar>

      <Offcanvas style={{width:'60%'}} show={show} onHide={handleClose} placement='end'>
        <Offcanvas.Header style={{paddingBottom:'0'}} closeButton>
          <Offcanvas.Title className='d-flex w-75' ><BsPersonCircle size={50}/> <p style={{fontSize:'medium',textTransform:'capitalize',padding:'0px 7px'}} >{user && user.name? user.name.toLowerCase():null}</p></Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body >
          {/* {user && (user.role==='admin' || user.role==='fmbmember')?<MDBBtn block className='border-bottom m-0' color='link'>
          <NavLink to="/attendance" onClick={() => handleClose()}>Attendance</NavLink>
          </MDBBtn>:null} */}
          {user && (user.role==='admin' || user.role==='fmbmember')?<MDBBtn block className='border-bottom m-0' color='link'>
          <NavLink to="/dailyCount" onClick={() => handleClose()}>Daily Report</NavLink>
          </MDBBtn>:null}
          {user && (user.role==='admin' || user.role==='fmbmember')?<MDBBtn block className='border-bottom m-0' color='link'>
          <NavLink to="/attendanceCount" onClick={() => handleClose()}>Filling Report</NavLink>
          </MDBBtn>:null}
          {user && (user.role==='admin' || user.role==='fmbmember')?<MDBBtn block className='border-bottom m-0' color='link'>
          <NavLink to="/scanning" onClick={() => handleClose()}>Scanning</NavLink>
          </MDBBtn>:null}
          {user && (user.role==='admin' || user.role==='fmbmember')?<MDBBtn block className='border-bottom m-0' color='link'>
          <NavLink to="/rsvpCount" onClick={() => handleClose()}>RSVP Report</NavLink>
          </MDBBtn>:null}
          {user && (user.role==='admin' || user.role==='fmbmember')?<MDBBtn block className='border-bottom m-0' color='link'>
          <NavLink to="/feedbackReport" onClick={() => handleClose()}>Feedback Report</NavLink>
          </MDBBtn>:null}
          {/* {user && user.role==='admin'?<MDBBtn block className='border-bottom m-0' color='link'>
          <NavLink to="/niyaazUpload" onClick={() => handleClose()}>Niyaaz</NavLink>
          </MDBBtn>:null} */}
          {/* {user && user.role==='admin'?<MDBBtn block className='border-bottom m-0' color='link'>
          <NavLink to="/notify" onClick={() => handleClose()}>Send Notifications</NavLink>
          </MDBBtn>:null} */}
          {user && user.role==='admin'?<MDBBtn block className='border-bottom m-0' color='link'>
          <NavLink to="/payment" onClick={() => handleClose()}>Profiles</NavLink>
          </MDBBtn>:null}
          {/* {user && user.role==='admin'?<MDBBtn block className='border-bottom m-0' color='link'>
          <NavLink to="/viewPayment" onClick={() => handleClose()}>View Payments</NavLink>
          </MDBBtn>:null} */}
          <MDBBtn block className='border-bottom m-0' color='link'>
          <NavLink to="/profile" onClick={() => handleClose()}>{user?.role==='admin'?'Edit Profiles':'My Profile'}</NavLink>
          </MDBBtn>
          <MDBBtn block className='border-bottom m-0' color='link'>
          {user?  <NavLink to="/logout" onClick={() => handleClose()}>Logout</NavLink>: <NavLink to="/login" onClick={() => handleClose()}>Login</NavLink>}
          </MDBBtn>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}